var map = {
	"./Voice-BG-img.jpg": "682c",
	"./apple-pay.svg": "4dea",
	"./bmwcharging-logo@2x.png": "1a6e",
	"./bmwcharging-logo@2x.webp": "b704",
	"./dcs-logo@2x.png": "6cbe",
	"./dcs-logo@2x.webp": "3846",
	"./etron-logo@2x.png": "2c32",
	"./etron-logo@2x.webp": "8367",
	"./google-pay.svg": "6b60",
	"./hamburgenergie-logo@2x.png": "239b",
	"./hamburgenergie-logo@2x.webp": "e7fa",
	"./ladenetz-logo@2x.png": "57aa",
	"./ladenetz-logo@2x.webp": "6bc3",
	"./maestro.svg": "0389",
	"./maingau-logo@2x.png": "8cba",
	"./maingau-logo@2x.webp": "723b",
	"./map-GERMANY-de.png": "61d7",
	"./map-GERMANY-de.webp": "0202",
	"./map-GERMANY-en.png": "66ef",
	"./map-GERMANY-en.webp": "9c4b",
	"./map-SWEDEN-en.png": "1356",
	"./map-SWEDEN-en.webp": "332e",
	"./map-SWEDEN-sv.png": "2e6e",
	"./map-SWEDEN-sv.webp": "625c",
	"./mastercard.svg": "609e",
	"./mercedesme-logo@2x.png": "b1fb",
	"./mercedesme-logo@2x.webp": "35f8",
	"./mini-logo@2x.png": "8d90",
	"./mini-logo@2x.webp": "4aa8",
	"./myeasycharge-logo@2x.png": "f183",
	"./myeasycharge-logo@2x.webp": "2cfd",
	"./navigate-ic.svg": "e39b",
	"./payment.svg": "c2cd",
	"./pole-blue.jpg": "7ad2",
	"./pole-blue.webp": "a7e8",
	"./pole-green.jpg": "59b4",
	"./pole-homepage-bottom-POLAND.jpg": "b5e2",
	"./pole-homepage-bottom-POLAND.webp": "777b",
	"./pole-homepage-bottom.jpg": "3553",
	"./pole-homepage-bottom.webp": "6074",
	"./pole-red.jpg": "c90a",
	"./pole-red.webp": "44cf",
	"./pole-status-green.png": "1412",
	"./pole-status-green.webp": "575a",
	"./pole-status-red.png": "9ab4",
	"./pole-status-red.webp": "42af",
	"./pole-status-yellow.png": "6e5c",
	"./pole-status-yellow.webp": "6d2c",
	"./pole-yellow.jpg": "9fa2",
	"./pole-yellow.webp": "1737",
	"./pole.webp": "78df",
	"./reserved-pin.svg": "ec65",
	"./samsung-pay.svg": "0d09",
	"./status-light-POLAND.webp": "0bbc",
	"./swish.png": "cf6e",
	"./swm-logo@2x.png": "ae0a",
	"./swm-logo@2x.webp": "6b43",
	"./tnm-logo@2x.png": "12b8",
	"./tnm-logo@2x.webp": "150b",
	"./tutorial-pole.png": "bed4",
	"./tutorial-pole.webp": "3983",
	"./v-pay@2x.png": "676a",
	"./v-pay@2x.webp": "dc34",
	"./visa-ic@2x.png": "db99",
	"./voice_desktop.svg": "e48f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3e81";